import { CreateProductSetBody } from "../apis";
import { ProductSetFormValues } from "../productsSets.types";

export const convertProductSetFormDataToCreateRequestBody = (
  formData: ProductSetFormValues
): CreateProductSetBody => {
  return {
    coverMediaId: String(formData.coverMedia?.id),
    title: formData.title,
    description: formData.description,
    showOnHome: formData.showOnHome,
    showInSearch: formData.showInSearch,
    allowCoverMediaDisplayInFullScreenMode:
      formData.allowCoverMediaDisplayInFullScreenMode,
    productVariantIds: formData.productVariants.map((product) => product.id)
  };
};
